import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .counter-label {
        position: absolute;
        top: 0.5em;
        left: 0;
        width: 100%;
        margin: auto;
        color: #FFFFFF;
        text-transform: uppercase;

        span {
            display: block;
            width: max-content;
            margin: 0 auto;
            font-weight: bold;
            font-size: 0.85em;
        }
    }

    .counter {
        position: fixed;
        z-index: 8;
        top: 80px;
        left: 50%;
        transform: translate(-50%, 10px);
        padding: 1.4em 2em 0.6em 2em;
        background-color: rgba(19, 19, 19, 0.9);
        display: flex;
        gap: 26px;
        border-radius: 1em;

        &.has-navigation {
            top: 130px;
        }

        .day,
        .hours,
        .minutes {
            position: relative;

            &:after,
            &:before {
                position: absolute;
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 6px;
                background-color: #FFFFFF;
                right: calc(-26px + 9px)
            }

            &:after {
                top: 16px;
            }

            &:before {
                top: 26px;
            }

        }

        .day,
        .hours,
        .minutes,
        .seconds {
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 30px;
            font-weight: bold;

            span {
                font-size: 14px;
                color: #BA9449;
            }
        }

        .expired {
            color: #FFFFFF;
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        .counter {
            top: 70px;

            &.has-navigation {
                top: 70px;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .counter {
            .day,
            .hours,
            .minutes,
            .seconds {
                font-size: 24px;

                &:after,
                &:before {
                    width: 5px;
                    height: 5px;
                    border-radius: 5px;
                    right: calc(-26px + 8px)
                }

                &:after {
                    top: 12px;
                }

                &:before {
                    top: 20px;
                }

                span {
                    font-size: 12px;
                    color: #BA9449;
                }
            }
        }
    }
`;
